import { render } from "./ScrollIndicator.vue?vue&type=template&id=0cddaa36"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__